import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { ENTITY } from '../config';
import { AllEntityId } from '../config/allEntityId';
import { useCampaignGroupEnabled } from '../modules/campaigns-group-form/hooks/useCampaignGroupEnabled';
import { useReportEntityIds } from './useReportEntityIds';
import { useReportEntityType } from './useReportEntityType';
import { useSelectedCampaign } from './useSelectedCampaign';
import { useSelectedCampaignGroup } from './useSelectedCampaignGroup';

export const useEntityTitle = () => {
    const { formatMessage } = useIntl();
    const { campaignGroup } = useSelectedCampaignGroup();
    const { campaign } = useSelectedCampaign();
    const [selectedReportEntityIds] = useReportEntityIds();
    const isCampaignGroupExtensionEnabled = useCampaignGroupEnabled();
    const [entityType] = useReportEntityType();

    const defaultTitle = isCampaignGroupExtensionEnabled
        ? formatMessage({ id: 'app.campaigns.all.CAMPAIGN_GROUP', defaultMessage: 'All Campaign Groups' })
        : formatMessage({ id: 'app.campaigns.all.CAMPAIGN', defaultMessage: 'All Campaigns' });

    if (selectedReportEntityIds === AllEntityId) {
        return defaultTitle;
    }

    if (entityType === ENTITY.CAMPAIGN) {
        return campaign?.name;
    }

    if (entityType === ENTITY.CAMPAIGNS_GROUP) {
        return campaignGroup?.campaignsGroupName;
    }

    return defaultTitle;
};
